import eventBus from "../services/event-bus";
import { elementExists } from "../utils";
const InitFreeShippingNotices = function(){
    const CartService = Shopify.cartService
    let $containers = document.querySelectorAll( "[cart-free-shipping-notice]" );

    const FreeShippingNotice = function( $container ){
        let app = {
            data :{
                threshold : 12,
                thresholdType : 'quantity',
                noticePassed : 'You have free shipping!',
                noticeAlmostPassed : 'Add __AMOUNT__ more to get free shipping!',
            },
            init() {
                app.data = {...app.data,...$container.dataset};
                app.data.threshold = parseInt( app.data.threshold );
                if (typeof (Shopify.theme.cartOnLoad)) {
                    app.check(Shopify.theme.cartOnLoad)
                }
                eventBus.on(eventBus.types.CartUpdated, function ($data) {
                    app.check(CartService.cart)
                })
            },
            check($cart) {
                if( app.data.thresholdType == 'price' ){
                    $container.innerHTML = app.priceCheck( $cart );
                }else{
                    $container.innerHTML = app.quantityCheck( $cart );
                }
            },
            priceCheck( $cart ){
                let cart_price = ($cart.total_price / 100);
                const excludedProducts = app.data.excludedProducts;
                if (typeof( excludedProducts )!== 'undefined' &&  excludedProducts.length > 0  ) {
                    cart_price = 0;
                    $cart.items.forEach(item => {
                        if (!excludedProducts.includes(item.product_id)) {
                            cart_price += (item.final_line_price / 100);
                        }
                    });
            }
                if (app.data.threshold > cart_price) {
                    notice = app.data.noticeAlmostPassed.replace('__AMOUNT__', (app.data.threshold - cart_price).toFixed(2));
                } 
                return notice
            },
            quantityCheck( $cart ){
                let notice = app.data.noticePassed;
                let cart_quantity = $cart.item_count;
                const excludedProducts = app.data.excludedProducts;
                if (typeof( excludedProducts )!== 'undefined' &&  excludedProducts.length > 0  ) {
                    $cart.items.forEach(item => {
                        if (!excludedProducts.includes(item.product_id)) {
                            cart_quantity += item.quantity;
                        }
                    });
                } 
                if (app.data.threshold > cart_quantity) {
                    notice = app.data.noticeAlmostPassed.replace('__AMOUNT__', (app.data.threshold - cart_quantity));
                } 
                return notice
            }
        }
        app.init();

    }

    if( elementExists( $containers , true  ) ){
        $containers.forEach( function( $container ){
            FreeShippingNotice( $container );
        });
	}


}

export default InitFreeShippingNotices;